<!-- 
화면명 : UCVendor.vue
작성일 : 2025-07-01
설명   : 거래선 컨트롤
-->
<template>
  <div class="flex items-center space-x-2 w-full max-w-md">
    <img src="@/assets/img/blue-circle.png" class="w-3 h-3" />

    <label class="text-sm font-medium text-blueGray-700 whitespace-nowrap">
      {{ title }}
    </label>

    <!-- 업체코드 -->
    <input
      v-model="vendorCode"
      placeholder="업체코드"
      class="w-28 px-3 py-2 border border-blueGray-300 bg-gray-200 rounded text-sm"
      readonly
    />

    <!-- 돋보기 버튼 -->
    <!-- <button
      @click="openVendorPopup"
      class="absolute pl-40 text-blueGray-400 hover:text-lightBlue-500 pointer-events-none"
      title="업체 검색"
    >
      🔍
    </button> -->

    <!-- 업체명 -->
    <!-- <span class="ml-2 text-sm text-blueGray-700 w-20 truncate">
      {{ vendorName }}
    </span> -->
    <input
      v-model="vendorName"
      placeholder="업체명"
      class="w-48 px-3 py-2 border border-blueGray-300 bg-gray-200 rounded text-sm"
      readonly
    />

    <!-- 팝업 -->
    <!-- <VendorPopup
      v-if="showPopup"
      @close="showPopup = false"
      @select="handleSelect"
    /> -->
  </div>
</template>

<script setup>
import { ref, defineProps, onMounted } from "vue";
// import VendorPopup from "./VendorPopup.vue"; // 팝업 컴포넌트

// Props
const props = defineProps({
  title: String,
  VendCd: String,
  VendName: String,
});

const vendorCode = ref("");
const vendorName = ref("");

onMounted(() => {
  // console.log("mounted");

  if (props.VendCd) {
    vendorCode.value =
      props.VendCd.substring(0, 3) +
      "-" +
      props.VendCd.substring(4, 2) +
      "-" +
      props.VendCd.substring(6);
  }

  vendorName.value = props.VendName;
});

const showPopup = ref(false);

const openVendorPopup = () => {
  showPopup.value = true;
};

const handleSelect = (vendor) => {
  vendorCode.value = vendor.code;
  vendorName.value = vendor.name;
  showPopup.value = false;
};
</script>
